<!-- LoadingModal.vue -->
<template>
  <div class="loading">
    <myModal
      :transition-name="''"
      :mask-transition-name="''"
      :closable="false"
      centered
      width="max-content"
      class="loading-modal"
      :visible="visible"
      :z-index="1999"
      :maskStyle="{ 'background-color': 'rgba(0, 0, 0, 0.6)' }"
      @close="close($event)"
    >
      <template #body>
        <!-- <div class="spin-state">
          Loading state：
          <a-switch :checked="visible" @change="change($event)" />
        </div> -->
        <div class="sprite-animation">
          <!-- <a-spin tip="Loading..." :visible="visible"></a-spin> -->
          <div class="loading_animation"></div>
        </div>
      </template>
    </myModal>

    <!-- <myModal :width="'3rem'" :visible="visible" @close="close($event)">
      <template #body>loading</template>
    </myModal> -->
  </div>
</template>

<script setup>
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(["update:visible", "closed"]);
console.log("props;", props);

function change(e) {
  // $emit('update:visible', $event)
  // emits('update:visible', false)
  close();
}
function close(e) {
  console.log("关闭loading;", e);
  emits("closed", false);
}
</script>
<style lang="scss" scoped>

//loading动画
.loading-modal {
  :deep(.ant-modal-content) {
    background-color: transparent;
  }
  // :deep(.ant-modal-close){
  //     display: none;
  //   }
  :deep(.ant-modal-body) {
    // width: 2rem;
    // height: 2rem;
    @extend %flex-all-center;
    flex-direction: column;

    .sprite-animation {
      width: 1.4rem;
      height: 1.84rem;
      overflow: hidden;
      position: relative;
    }

    .loading_animation {
      width: 1.4rem;
      height: 1.84rem;
      background: url("@/assets/images/systemicon/loading.png") 0 0 no-repeat;
      background-size: 89.6rem 1.84rem;
      animation: play 2.14s steps(64) infinite; /* 每秒播放一次，总共5帧，循环播放 */
    }
    @keyframes play {
      from {
        background-position: 0 0;
      }
      to {
        background-position: -89.6rem 0; /* 移动总宽度的100% */
      }
    }
  }
}
</style>
